import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import Utils from './../../component/utils/utils';
import DatePicker from './../../component/datePicker';
import InputSearchField from './../../component/inputSearchField';
import AdHocViewEnum from './adHocViewEnum';
import Select from './../../component/select';

class TableView extends Component {
    // START private methods
    _callServiceFetch(page) {
        this.setState({
            showMask: true
        });

        var searchParams = this._createSearchParamsObject();
        Service.fetchAdHocReport(page, searchParams, this.viewType).finally(() => {
            this.setState({ showMask: false });
        });
    }

    _callServiceDownloadFile() {
        var searchParams = this._createSearchParamsObject();
        Service.downloadAdHocReport(searchParams, this.viewType);
    }

    _createSearchParamsObject(page) {
        var searchParams = {};
        searchParams.createdDateStart = this.createdDateStart;
        searchParams.createdDateEnd = this.createdDateEnd;
        searchParams.openSearch = this.searchInputFieldValue;
        searchParams.searchAccountId = this.searchAccountIdInputFieldValue;

        return searchParams;
    }
    // END private methods

    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "Ad Hoc Referral",
        pagingMetadata: [],
        responseTableData: {},
        showMask: false
    }

    constructor() {
        super();
        // setting default attribute values
        this.viewType = AdHocViewEnum.REFERRAL;
        this.currentPage = 0;
        this.createdDateStart = "";
        this.createdDateEnd = "";
        this.searchInputFieldValue = "";
        this.searchAccountIdInputFieldValue = "";
        this.statusDropdownValue = "";

        this.tableHeaderColumnList = [
            { columnName: "Referral ID", key: "referralId"},
            { columnName: "Referral Code", key: "referralCode"},
            { columnName: "Account ID", key: "sourceAccountId"},
            { columnName: "Created Date", key: "createdDate"},
            { columnName: "Coupon Id", key: "couponId"},
            { columnName: "Redeemed", key: "redeemed"},
            { columnName: "Redeemed Date", key: "redeemedDate"},
            { columnName: "Credited To Referrer", key: "creditedToReferrer"},
            { columnName: "Credited Date", key: "creditedDate"},
            { columnName: "Account Referral Code Id", key: "accountReferralCodeId"},
            { columnName: "Account Referral Code Name", key: "accountReferralCodeName"}
        ]
    }

    componentDidMount () {
        var fetchEventForResultData = Service.getEventSignal(this.viewType);

        fetchEventForResultData.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    onStartCreateDateFieldChange = (value) => {
        this.createdDateStart = value;
    };

    onEndCreateDateFieldChange = (value) => {
        this.createdDateEnd = value;
    };

    onSearchFieldChange = (value) => {
        this.searchInputFieldValue = value;
    };

    onSearchAccountIdFieldChange = (value) => {
        this.searchAccountIdInputFieldValue = value;
    };

    // table actions
    searchButtonAction = () => {
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    downloadFileAction = () => {
        this._callServiceDownloadFile();
    };

    handleStatusDropdownChange = (event) => {
        this.statusDropdownValue =  event.target.value;
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        downloadFileAction = {this.downloadFileAction}
                        type = "adHocReport"
                    >
                        <InputSearchField
                            fieldId = "adHocSearchAccountIdField"
                            placeHolderText = "Account ID"
                            onChange = {this.onSearchAccountIdFieldChange}
                        />
                        <DatePicker
                            fieldId = "adHocReferralCreateStartDatePicker"
                            placeHolderText = "Created Start Date"
                            onChange = {this.onStartCreateDateFieldChange}
                            fieldType = "startDate"
                        />
                        <DatePicker
                            fieldId = "adHocReferralCreateEndDatePicker"
                            placeHolderText = "Created End Date"
                            onChange = {this.onEndCreateDateFieldChange}
                            fieldType = "endDate"
                        />
                        <InputSearchField
                            fieldId = "adHocSearchField"
                            placeHolderText = "Search"
                            onChange = {this.onSearchFieldChange}
                        />
                    </TableSearchHeader>
                   <TableHead
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                   />
                   <TableBody
                       tableDataResults = {this.state.responseTableData.results}
                       tableHeaderColumnList = {this.tableHeaderColumnList}
                       type = "adHocReport"
                       showMask = {this.state.showMask}
                   >

                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;